module.exports = __webpack_public_path__ + "img/thumbnail_size-medium.d22be1f6.svg";